// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FCTEN","headline":"styles_headline__yA+xI","title":"styles_title__7c4sK","carouselButtons":"styles_carouselButtons__4Cjlx"};